<h1 mat-dialog-title>Add Induction Attendee</h1>


<div mat-dialog-content style="display: flex;flex-direction: column;">

  <div style="display:flex;flex-direction:row;justify-content: space-between;">
    
    <div style="display:flex;flex-direction:column;justify-content: space-around;align-items: center;">
      <i *ngIf="!ImagePreview || ImagePreview.length <= 0" class="material-icons alert__icon">photo_camera</i>
      <img *ngIf="ImagePreview && ImagePreview.length >0" [src]="ImagePreview" alt="No File Uploaded"
          style="width:200px;margin-left: 10px;">
      <label>
        <input #imageInput type="file" accept="image/*" (change)="onFileChanged($event);">
      </label>
    </div>

    <div style="display:flex;flex-direction:column;justify-content: space-between;">
    <div class="example-full-width" style="width: 500px;display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;margin-top: 12px;">
      <mat-label style="font-weight: bold;min-width: 120px;">First Name</mat-label>
      <input style="width: 500px;" type="text" matInput placeholder=" First Name " [(ngModel)]="fName" class="get-Input">
    </div>

    <div class="example-full-width" style="width: 500px;display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;margin-top: 12px;">
    <mat-label style="font-weight: bold;min-width: 120px;">Last Name</mat-label>
    <input style="width: 500px;" type="text" matInput placeholder="Last Name" [(ngModel)]="lName" class="get-Input">
  </div>
</div>
  </div>

  <div class="example-full-width" style="width: 500px;display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;margin-top: 12px;">
    <mat-label style="font-weight: bold;min-width: 120px;">Email Address</mat-label>
    <input style="width: 500px;" type="text" matInput placeholder="Email Address" [(ngModel)]="EmailAddress" class="get-Input">
  </div>

  <div class="example-full-width" style="width: 500px;display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;margin-top: 12px;">
    <mat-label style="font-weight: bold;min-width: 120px;">Company</mat-label>
    <input style="width: 500px;" type="text" matInput placeholder="Company" [(ngModel)]="Company" class="get-Input">
  </div>

  <div class="example-full-width" style="width: 500px;display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;margin-top: 12px;">
    <mat-label style="font-weight: bold;min-width: 120px;">Position</mat-label>
    <input style="width: 500px;" type="text" matInput placeholder="Position" [(ngModel)]="Position" class="get-Input">
  </div>


</div>
<div mat-dialog-actions class="dialogControllBtn">
  <a class="button button--primary" style="margin-left: 20px;" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
  <button [disabled]="fName=='' && lName=='' && EmailAddress==''" class="button button--primary" style="margin-left: 20px;" (click)="onSubmitClick()"><span class="button__text">Submit</span></button>
</div>